export enum EnumLogRecordQuery {
  /**	狀態碼 */
  status = 'status',
  /**	錯誤訊息 */
  message = 'message',
  /**  data */
  dat = 'dat',
  /**	回傳資訊 */
  contents = 'contents',
  /**	異動類別 */
  actionType = 'actionType',
  /**	異動類別中文 */
  actionTypeName = 'actionTypeName',
  /**	文件類型 */
  docType = 'docType',
  /**	文件類型中文 */
  docTypeName = 'docTypeName',
  /**	單據號碼 */
  docNo = 'docNo',
  /**	通路別代碼 */
  retailerId = 'retailerId',
  /**	分店代碼 */
  storeNo = 'storeNo',
  /**	供應商代碼 */
  supplierCode = 'supplierCode',
  /**	下載時間 */
  downloadDate = 'downloadDate',
  /**	單據序號 */
  docSeqNo = 'docSeqNo',
  /**	傳輸格式 */
  flatType = 'flatType',
  /**	TXT CSV */
  flatStyle = 'flatStyle',
  /**	版本號 */
  version = 'version',
  /**	輸出檔名 */
  exportFileName = 'exportFileName',
  /**	使用者IP */
  userIP = 'userIP',
  /**	使用者帳號 */
  userId = 'userId',
}
export default EnumLogRecordQuery;
